import React, { useRef, useState } from "react";

function DiscountVersionPicker({ discount, versions }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const timeoutRef = useRef(null);

  const handleSelect = (version) => {
    window.location = `/discounts/${version.id}`
  };

  // Start timeout to close dropdown
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setShowDropdown(false), 200); // 300ms delay
  };

  // Cancel timeout if mouse re-enters
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setShowDropdown(true);
  };

  return (
    <div
      className="relative inline-block w-8"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer px-2 py-1 rounded hover:bg-gray-100 focus:outline-none"
        onClick={() => setShowDropdown((open) => !open)}
        type="button"
      >
        { `V${discount.version_number}` }
        {hovered && (
          <svg
            className="ml-1 w-3 h-3 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 12 12"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6l2 2 2-2" />
          </svg>
        )}
      </button>
      {showDropdown && (
        <div className="absolute left-0 z-10 mt-1 w-40 bg-white border border-gray-200 rounded shadow-lg">
          {versions.map((v) => (
            <div
              key={v.id}
              className={`flex justify-between px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                v.id === discount.id ? "font-bold text-blue-600" : ""
              }`}
              onClick={() => handleSelect(v)}
            >
              <span>{`V${v.version_number}` }</span>
              <span className="ml-2 text-xs text-gray-400">{v.state}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DiscountVersionPicker;